import React from 'react'
import moment from 'moment'
import { Text } from './Text'
import { Icon } from './Icon'
import { Flex } from './Flex'

const ArrowIcon = () => (
  <Flex row as js style={{ marginTop: 2, marginLeft: 10, marginRight: 10 }}>
    <Icon name='minus-2' color='black' size={18} />
    <Icon name='right' color='black' size={15} style={{ marginTop: 1, marginLeft: -11 }} />
  </Flex>
)

export const LogsView = ({ style, value, title, extraText }) => {
  const renderLogs = (log, index = 1, lengthArr = 0, requestFlag = false) => (
    <div key={index} style={{ display: 'flex', flexDirection: 'row' }}>
      <Text color='#008800' value={moment(log.lastUpdate).format('DD/MM/YYYY, HH:mm')} style={{ marginRight: 5 }} />
      <ArrowIcon />
      <Text color='#1194d0' value={log.operator || log.user} style={{ marginRight: 5 }} />
      <ArrowIcon />
      <Text
        bold value={(index === lengthArr - 1 && !log.action)
          ? `Ha creato ${extraText}`
          : log.action || `Ha modificato ${extraText}`}
      />
    </div>
  )
  return (
    <div style={{ width: '100%', height: '100%', ...style }}>
      <Text bold value={title} />
      {value.length
        ? Array.isArray(value) ? value.map((log, index) => (log ? renderLogs(log, index, value.length) : null)) : renderLogs(value)
        : <Text value='Nessuna attività ad ora registrata' />}
    </div>
  )
}
